import React from 'react';
import EcoClub7Class2025 from '../views/EcoClub7Class2025/EcoClub7Class2025';

const DesktopAppPage = () => {
  return <EcoClub7Class2025 />;
};

export default DesktopAppPage;
